import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ user, children, requiredRole }) => {
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (requiredRole) {
        const hasRole = user.roles && Array.isArray(user.roles) && user.roles.includes(requiredRole);
        if (!hasRole) {
            return <Navigate to="/" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;